import { PackageCurrency } from '@/services/subscriptions/types';
import { LanguagesEnum } from '@/utils/enums/Languages';

export enum Region {
  TR = LanguagesEnum.Turkish,
  AZ = LanguagesEnum.Azerbaijan,
}

export interface RegionConfig {
  name: string;
  logo: {
    src: string;
    width: number;
    height: number;
  };
  currency: PackageCurrency;
  locale: string;
  loginImage: string;
}

const REGION_CONFIG: Record<Region, RegionConfig> = {
  [Region.TR]: {
    name: 'E12',
    locale: 'tr-TR',
    currency: PackageCurrency.TRY,
    logo: {
      src: '/logo/tr/logo.svg',
      width: 80,
      height: 30,
    },
    loginImage: '/login/tr/login.webp',
  },
  [Region.AZ]: {
    name: 'ESchool',
    locale: 'az-AZ',
    currency: PackageCurrency.USD,
    logo: {
      src: '/logo/az/logo.svg',
      width: 120,
      height: 30,
    },
    loginImage: '/login/az/login.webp',
  },
};

export const getRegion = (): Region => {
  return (import.meta.env.VITE_REGION as Region) || Region.TR;
};

export const getRegionConfig = () => {
  const region = getRegion();
  return REGION_CONFIG[region];
};
